import openseadragon from 'openseadragon';

import globals from '../globals';
import helpers from '../helpers';

const $mosaic = $('.mosaic');
const $container = $mosaic.find('.mosaic__container');
const $overlay = $mosaic.find('.mosaic__overlay');
const $popup = $mosaic.find('.mosaic__popup');
const $close = $mosaic.find('.mosaic__close');
const $image = $mosaic.find('.mosaic__image');
const $title = $mosaic.find('.mosaic__title');
const $text = $mosaic.find('.mosaic__text');
const $share = $mosaic.find('.mosaic__share');

const requestUrls = {
	cells: './data/cells.json',
	image: './data/image.json',
};

const maxZoomRatio = 2.5;
const animationDuration = 1;
const showPopupDelay = animationDuration * 1000 + 250;
const clickSafeZone = 2;
const minPopupWidth = 200;
const maxPopupTextLength = 100;
const cellSize = {
	width: 200,
	height: 200,
};

let cellsData = null;
let viewer = null;
let isAnimating = false;
let isDragging = false;
let popupTimeout = null;
let zoomRation = null;

function getImageCoordinates(e) {
	return typeof e === 'undefined' || viewer === null ? null : viewer.viewport.viewportToImageCoordinates(viewer.viewport.pointFromPixel(e.position));
}

function getImageZoom() {
	return viewer === null ? null : viewer.viewport.viewportToImageZoom(viewer.viewport.getZoom());
}

function setMosaicHeight() {
	if (helpers.isDesktop()) {
		$mosaic.removeAttr('style');

		return;
	}

	$mosaic.outerHeight(innerHeight);
}

function setOverlayParam(e) {
	if (viewer.source === null) {
		return;
	}

	const imageCoordinates = getImageCoordinates(e);

	if (
		imageCoordinates.x < 0 || imageCoordinates.x > viewer.source.width ||
		imageCoordinates.y < 0 || imageCoordinates.y > viewer.source.height ||
		isAnimating
	) {
		$container.removeClass('is-hover');
		$overlay.removeClass('is-active');

		return;
	}

	$container.addClass('is-hover');

	const imageBounds = new openseadragon.Rect(0, 0, viewer.source.width, viewer.source.height);
	const imageOffset = viewer.viewport.imageToViewerElementCoordinates(imageBounds.getTopLeft());
	const imageZoomLevel = getImageZoom();
	const cellPositionX = imageCoordinates.x - imageCoordinates.x % cellSize.width;
	const cellPositionY = imageCoordinates.y - imageCoordinates.y % cellSize.height;
	const overlayWidth = cellSize.width * imageZoomLevel;
	const overlayHeight = cellSize.height * imageZoomLevel;
	const overlayPositionX = imageOffset.x + cellPositionX * imageZoomLevel;
	const overlayPositionY = imageOffset.y + cellPositionY * imageZoomLevel;
	const row = cellPositionX / cellSize.width + 1;
	const col = cellPositionY / cellSize.height + 1;

	if ($overlay.data('row') === row && $overlay.data('col') === col && $overlay.hasClass('is-active')) {
		return;
	}

	$overlay
		.addClass('is-active')
		.data({
			row,
			col,
		});

	gsap.to($overlay, {
		duration: 0.3,
		width: overlayWidth,
		height: overlayHeight,
		x: overlayPositionX,
		y: overlayPositionY,
	});
}

function resetOverlayParams() {
	$container.removeClass('is-hover is-dragging');

	$overlay
		.removeClass('is-active')
		.data({
			row: 0,
			col: 0,
		});
}

async function getCellId(x, y) {
	let id = null;

	if (typeof x === 'undefined' || typeof y === 'undefined') {
		return Promise.resolve(id);
	}

	if (cellsData === null) {
		await $.getJSON(requestUrls.cells).done((data) => {
			cellsData = data;
		});
	}

	for (let i = 0; i < cellsData.length; i++) {
		const cell = cellsData[i];

		if (+x === +cell.x && +y === +cell.y) {
			id = cell.id;

			break;
		}
	}

	return Promise.resolve(id);
}

async function getCellCoordinates(id) {
	let coordinates = null;

	if (typeof id === 'undefined') {
		return Promise.resolve(coordinates);
	}

	if (cellsData === null) {
		await $.getJSON(requestUrls.cells).done((data) => {
			cellsData = data;
		});
	}

	for (let i = 0; i < cellsData.length; i++) {
		const cell = cellsData[i];

		if (+id === +cell.id) {
			coordinates = {
				x: cell.x,
				y: cell.y,
			};

			break;
		}
	}

	return Promise.resolve(coordinates);
}

function getPopupTitleMaxHeight() {
	let height = null;

	const div = document.createElement('div');

	div.classList.add('mosaic__title');
	div.style.margin = 0;
	div.style.padding = 0;
	div.innerHTML = 'A';

	$popup.append(div);

	height = div.clientHeight * 3;

	$(div).remove();

	return height;
}

function setPopupTextHeight() {
	$text.height('');

	if (helpers.isMobile()) {
		return;
	}

	if (helpers.isIE() && $text.text().length > maxPopupTextLength) {
		const truncatedText = $text.text().substring(0, maxPopupTextLength);

		$text.text(`${truncatedText}...`);

		return;
	}

	let height = null;

	const div = document.createElement('div');

	div.classList.add('mosaic__text');
	div.style.margin = 0;
	div.style.padding = 0;
	div.innerHTML = 'A';

	$popup.append(div);

	height = div.clientHeight * 3;

	$(div).remove();

	if ($text.height() >= height) {
		$text.height(`${height}px`);
	}
}

function setPopupStylesAndContent(data) {
	const $shareInner = $share.find('.share');

	const cellWidth = cellSize.width * maxZoomRatio;
	const cellHeight = cellSize.height * maxZoomRatio;
	const popupPaddingX = $popup.outerWidth() - $popup.width();
	const popupPaddingY = $popup.outerHeight() - $popup.height();
	const popupWidth = cellWidth < minPopupWidth ?
		minPopupWidth + popupPaddingX :
		cellWidth + popupPaddingX;
	const popupMarginTop = -cellHeight / 2 - popupPaddingY / 2;
	const popupMarginLeft = -popupWidth / 2;

	$popup.css({
		marginTop: helpers.isMobile() ? '' : popupMarginTop,
		marginLeft: helpers.isMobile() ? '' : popupMarginLeft,
		width: helpers.isMobile() ? '' : popupWidth,
	});

	if (!$image.find('img').length) {
		$image
			.css({
				width: helpers.isMobile() ? '' : cellWidth, // stylelint-disable-line value-keyword-case
				height: helpers.isMobile() ? '' : cellHeight, // stylelint-disable-line value-keyword-case
			})
			.html(`<img src="${data.image}" alt="${data.title}">`);
	} else {
		$image
			.css({
				width: helpers.isMobile() ? '' : cellWidth, // stylelint-disable-line value-keyword-case
				height: helpers.isMobile() ? '' : cellHeight, // stylelint-disable-line value-keyword-case
			})
			.find('img')
			.attr({
				src: data.image,
				alt: data.title,
			});
	}

	$title.html(data.title);
	$text.html(data.text);

	if ($shareInner.length) {
		$shareInner.attr({
			'data-url': data.share,
			'data-title': data.title,
		});
	}
}

function adjustPopupSizeAndPosition() {
	// значение 10 в mosaicOffsetBottom является произвольным отступом снизу
	// значение 20 в mosaicHeight является произвольным отступом сверху и снизу

	zoomRation = null;

	if (helpers.isMobile()) {
		return;
	}

	const mosaicOffsetBottom = $mosaic.offset().top + $mosaic.outerHeight() - 10;
	const popupOffsetBottom = $popup.offset().top + $popup.outerHeight();

	if (mosaicOffsetBottom >= popupOffsetBottom) {
		return;
	}

	const mosaicHeight = $mosaic.height() - 20;
	const popupPaddingX = $popup.outerWidth() - $popup.width();
	const popupPaddingY = $popup.outerHeight() - $popup.height();
	const titleMarginY = $title.outerHeight(true) - $title.height();
	const titleMaxHeight = getPopupTitleMaxHeight();
	const textHeight = $text.outerHeight(true);
	const shareHeight = $share.outerHeight(true) || 0;

	const cellHeight =
		mosaicHeight - popupPaddingY - titleMarginY -
		titleMaxHeight - textHeight - shareHeight;

	const cellHeightPercent = cellHeight / (cellSize.height * maxZoomRatio) * 100;
	const cellWidth = cellHeightPercent * (cellSize.width * maxZoomRatio) / 100;
	const popupWidth = cellWidth < minPopupWidth ?
		minPopupWidth + popupPaddingX :
		cellWidth + popupPaddingX;
	const popupMarginLeft = -popupWidth / 2;

	zoomRation = cellHeightPercent * maxZoomRatio / 100;

	$popup.css({
		marginLeft: popupMarginLeft, // stylelint-disable-line value-keyword-case
		width: popupWidth, // stylelint-disable-line value-keyword-case
	});

	$image.css({
		width: cellWidth, // stylelint-disable-line value-keyword-case
		height: cellHeight, // stylelint-disable-line value-keyword-case
	});

	const popupMarginTop = -$popup.outerHeight() / 2;

	$popup.css({
		marginTop: popupMarginTop, // stylelint-disable-line value-keyword-case
	});
}

function loadPopupData(id) {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: `https://ria.ru/services/breathe/popup/${id}.json`,
			timeout: 30000,
			success(data) {
				setTimeout(() => {
					setPopupStylesAndContent(data);
					setPopupTextHeight();
					adjustPopupSizeAndPosition();
					resolve();
				}, 150);
			},
			error: reject,
		});
	});
}

function showPopup() {
	return new Promise((resolve) => {
		clearTimeout(popupTimeout);

		popupTimeout = setTimeout(() => {
			$popup.addClass('is-active');

			helpers.lockScroll(helpers.isMobile(), $popup);

			resolve();
		}, showPopupDelay);
	});
}

function hidePopup() {
	if (!$popup.hasClass('is-active')) {
		return;
	}

	$popup.removeClass('is-active');

	helpers.lockScroll(false, $popup);
}

async function selectCell(e) {
	const imageCoordinates = getImageCoordinates(e);

	hidePopup();

	if (
		imageCoordinates.x < 0 || imageCoordinates.x > viewer.source.width ||
		imageCoordinates.y < 0 || imageCoordinates.y > viewer.source.height) {
		return;
	}

	const cellPositionX = imageCoordinates.x - imageCoordinates.x % cellSize.width;
	const cellPositionY = imageCoordinates.y - imageCoordinates.y % cellSize.height;
	const row = cellPositionX / cellSize.width + 1;
	const col = cellPositionY / cellSize.height + 1;

	$container.addClass('is-loading');

	try {
		await getCellId(row, col).then(loadPopupData);

		zoomRation = zoomRation ?? maxZoomRatio;

		let positionX = cellPositionX + cellSize.width / 2;
		let positionY = cellPositionY + cellSize.height / 2;
		let zoomToLevel = helpers.isMobile() ? 1 : zoomRation;

		if (zoomRation !== maxZoomRatio) {
			const popupOffsetTop = $popup.offset().top - $container.offset().top;
			const popupPaddingY = ($popup.outerHeight() - $popup.height()) / 2;
			const offsetTop = popupOffsetTop + popupPaddingY;

			positionY = cellPositionY + ($mosaic.height() / 2 - offsetTop) / zoomRation;
		}

		viewer.viewport.panTo(viewer.viewport.imageToViewportCoordinates(positionX, positionY));
		viewer.viewport.zoomTo(viewer.viewport.imageToViewportZoom(zoomToLevel));

		await showPopup();
	} catch (error) {
		console.log(error); // eslint-disable-line no-console

		alert('Ошибка загрузки данных'); // eslint-disable-line no-alert
	}

	$container.removeClass('is-loading');
}

async function selectCellById(e) {
	const id = e.currentTarget.dataset.id;

	hidePopup();

	if (typeof id === 'undefined') {
		return;
	}

	let positionX = null;
	let positionY = null;

	$container.addClass('is-loading');

	try {
		await loadPopupData(id);

		await getCellCoordinates(id).then((coordinates) => {
			positionX = coordinates.x * cellSize.width - cellSize.width / 2;
			positionY = coordinates.y * cellSize.height - cellSize.height / 2;
		});

		zoomRation = zoomRation ?? maxZoomRatio;

		if (zoomRation !== maxZoomRatio) {
			const popupOffsetTop = $popup.offset().top - $container.offset().top;
			const popupPaddingY = ($popup.outerHeight() - $popup.height()) / 2;
			const offsetTop = popupOffsetTop + popupPaddingY;

			positionY = positionY + cellSize.height / 2 + ($mosaic.height() / 2 - offsetTop) / zoomRation;
		}

		const zoomToLevel = helpers.isMobile() ? 1 : zoomRation;

		viewer.viewport.panTo(viewer.viewport.imageToViewportCoordinates(positionX, positionY));
		viewer.viewport.zoomTo(viewer.viewport.imageToViewportZoom(zoomToLevel));

		await showPopup();
	} catch (error) {
		console.log(error); // eslint-disable-line no-console

		alert('Ошибка загрузки данных'); // eslint-disable-line no-alert
	}

	$container.removeClass('is-loading');
}

function initViewerEvents() {
	if (viewer === null) {
		return;
	}

	viewer.addHandler('animation-start', () => {
		isAnimating = true;

		$overlay.removeClass('is-active');

		hidePopup();
	});

	viewer.addHandler('animation-finish', () => {
		isAnimating = false;
	});

	viewer.addHandler('canvas-press', () => {
		isDragging = false;
	});

	viewer.addHandler('canvas-release', (e) => {
		if (!isDragging) {
			selectCell(e);
		}
	});

	viewer.addHandler('canvas-pinch', () => {
		isDragging = true;
	});

	viewer.addHandler('canvas-drag', (e) => {
		if (
			e.delta.x < -clickSafeZone || e.delta.x > clickSafeZone ||
			e.delta.y < -clickSafeZone || e.delta.y > clickSafeZone
		) {
			isDragging = true;
		}

		$container.addClass('is-dragging');
	});

	viewer.addHandler('canvas-drag-end', () => {
		$container.removeClass('is-dragging');
	});
}

function initMouseTracker() {
	if (viewer === null) {
		return;
	}

	// eslint-disable-next-line no-new
	new openseadragon.MouseTracker({
		element: viewer.container,
		moveHandler: setOverlayParam,
		exitHandler: resetOverlayParams,
	});
}

async function initViewer() {
	if (viewer !== null) {
		return;
	}

	viewer = openseadragon({
		element: $container.get(0),
		tileSources: './images/mosaic.dzi?v=2',
		prefixUrl: './images/openseadragon/',
		autoHideControls: false,
		immediateRender: helpers.isTablet(),
		minZoomImageRatio: 0.5,
		maxZoomPixelRatio: maxZoomRatio + 0.1,
		iOSDevice: helpers.isIOS(),
		animationTime: animationDuration,
		gestureSettingsMouse: {
			clickToZoom: false,
		},
		gestureSettingsTouch: {
			dblClickToZoom: false,
		},
		gestureSettingsPen: {
			clickToZoom: false,
		},
		gestureSettingsUnknown: {
			dblClickToZoom: false,
		},
		showHomeControl: false,
		showFullPageControl: false,
		zoomInButton: 'mosaic-zoom-in',
		zoomOutButton: 'mosaic-zoom-out',
	});

	initViewerEvents();
	initMouseTracker();
}

function resize() {
	helpers.resize('mosaic', () => {
		setMosaicHeight();
		hidePopup();
	});
}

function init() {
	if (!$mosaic || !$mosaic.length) {
		return;
	}

	setMosaicHeight();
	initViewer();

	globals.$window
		.data('width-mosaic', innerWidth)
		.on('resize', resize);

	globals.$document
		.on('keydown.mosaic', (e) => {
			if (e.keyCode === 27) {
				hidePopup();
			}
		})
		.on('click.mosaic', '.js-mosaic-show', selectCellById);

	$close.on('click.mosaic', hidePopup);
}

init();
